module.exports = __webpack_public_path__ + "img/title.9a586042.png";